/* 🤖 this file was generated by script */
export const wiconPaperPlaneCheck = {
  name: 'paper_plane_check',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.02 3L2.98 7.93l6.47 2.57m7.57-7.52l-7.57 7.52m7.57-7.52l-1.19 3.33m-6.38 4.19l.63 1.59m2.7 2.78l-.76 2.13-.46-1.17M5.7 12.26l3.43 3.43 7.17-7.17"/></svg>`,
};
